import { useState, useEffect, useRef, useCallback } from 'react';

const useDropdown = (initialState = false, options = {}) => {
  const [isOpen, setIsOpen] = useState(initialState);
  const dropdownRef = useRef(null);
  const {
    onOpen = () => { },
    onClose = () => { },
    closeOnEscape = true,
    closeOnClickOutside = true
  } = options;

  const openDropdown = useCallback(() => {
    setIsOpen(true);
    onOpen();
  }, [onOpen]);

  const closeDropdown = useCallback(() => {
    setIsOpen(false);
    onClose();
  }, [onClose]);

  const toggleDropdown = useCallback(() => {
    if (isOpen) {
      closeDropdown();
    } else {
      openDropdown();
    }
  }, [isOpen, openDropdown, closeDropdown]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isOpen && closeOnEscape) {
        closeDropdown();
      }
    };

    const handleClickOutside = (e) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target) &&
        isOpen &&
        closeOnClickOutside
      ) {
        closeDropdown();
      }
    };

    if (isOpen) {
      if (closeOnEscape) {
        document.addEventListener('keydown', handleKeyDown);
      }
      if (closeOnClickOutside) {
        document.addEventListener('mousedown', handleClickOutside);
      }
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, closeOnEscape, closeOnClickOutside]);

  return {
    isOpen,
    setIsOpen,
    openDropdown,
    closeDropdown,
    toggleDropdown,
    dropdownRef
  };
};

export default useDropdown;